<tt-modal class="tt-c-warn-close-modal"
          :ariaLabel="$msg('warnCloseModal.label')"
          :isInsideModal="true"
          :centered="true"
          :showClose="false"
          @close="close">
  <tt-header class="tt-c-warn-close-modal__header" :heading="$msg('warnCloseModal.title')"></tt-header>
  <p class="tt-c-warn-close-modal__message" v-html="$msg('warnCloseModal.message')"></p>
  <div class="tt-c-warn-close-modal__actions tt-o-button-group">
    <tt-button ref="returnBtn" class="tt-c-warn-close-modal__return" type="primary" @click.prevent="close" v-html="$msg('warnCloseModal.return')"></tt-button>
    <tt-button class="tt-c-warn-close-modal__leave" type="secondary" @click.prevent="closeParentModal" v-html="$msg('warnCloseModal.leave')"></tt-button>
  </div>
</tt-modal>


// WEBPACK FOOTER //
// ./src/components/warn-close-modal/warn-close-modal.html